import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';

import type { TSimVariant } from '../../types';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const ChooseSimTypeItem: FC<
  TSimVariant & {
    href?: string;
    onClick?: (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  }
> = ({ title, text, icon, href, onClick }) => {
  const Tag = href ? 'a' : 'button';
  const hrefProp = href ? { href } : {};
  return (
    <Tag className={cx('item')} onClick={onClick} {...hrefProp}>
      {icon && <img alt="" className={cx('icon')} src={icon} />}
      {title && (
        <Text className={cx('title')} variant="body-small">
          {title}
        </Text>
      )}
      {text && (
        <Text className={cx('text')} variant="caption-medium">
          {text}
        </Text>
      )}
    </Tag>
  );
};
